import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ContTitleDesktop = styled.div`
  max-width: var(--pc-width);
  margin: 0 auto;
  padding: 72px 0 40px 0;

  .title {
    ${mixin.flex({ justify: 'space-between' })};

    .text {
      font-size: 38px;
      font-weight: 500;
      line-height: 130%;
    }
  }
`;
